import { useState } from 'react'
import { Link } from 'react-router-dom'

import Sociologo from '../../images/titulo_sociologo.jpg'
import RankProg from '../../images/rank_prog.jpg'

import './about.css'

const About = () => {
  const [credential, setCredential] = useState(null)

  const closeCredential = () => {
    setCredential(null)
  }

  return (
    <main className="about-page">

      {/* =====================================================
          HERO
          ===================================================== */}

      <section className="about-hero">
        <div className="about-hero__inner">

          <p className="about-eyebrow">
            PERFIL PROFESIONAL
          </p>

          <h1>
            Ciencias sociales,
            <span> datos y tecnología.</span>
          </h1>

          <p className="about-hero__lead">
            Soy Christian Castro, sociólogo y analista programador.
            Mi trabajo combina investigación social, análisis
            cuantitativo, programación y ciencia de datos para
            estudiar fenómenos sociales y territoriales.
          </p>

          <div className="about-hero__tags">
            <span>Sociología</span>
            <span>Demografía</span>
            <span>R</span>
            <span>Python</span>
            <span>Análisis territorial</span>
            <span>Ciencia de datos</span>
          </div>

        </div>
      </section>


      {/* =====================================================
          PRESENTACIÓN
          ===================================================== */}

      <section className="about-intro">
        <div className="about-intro__number">
          01
        </div>

        <div className="about-intro__content">
          <p className="about-eyebrow">
            UNA MIRADA INTERDISCIPLINARIA
          </p>

          <h2>
            Comprender la sociedad también requiere comprender
            sus datos.
          </h2>

          <p>
            Mi formación combina ciencias sociales y programación.
            Esa intersección permite abordar problemas de demografía,
            desigualdad, pobreza y territorio utilizando herramientas
            estadísticas y computacionales.
          </p>

          <p>
            Demográfica nace precisamente de esa combinación:
            conocimiento social, análisis de datos y desarrollo
            tecnológico aplicados a problemas reales.
          </p>
        </div>
      </section>


      {/* =====================================================
          FORMACIÓN
          ===================================================== */}

      <section className="about-education">

        <div className="about-section-heading">
          <p className="about-eyebrow">
            FORMACIÓN
          </p>

          <h2>Trayectoria académica y técnica.</h2>

          <p>
            Una formación construida entre las ciencias sociales,
            la programación y los métodos computacionales.
          </p>
        </div>


        <div className="education-grid">

          {/* UNIVERSIDAD DE CHILE */}

          <article className="education-card education-card--featured">

            <div className="education-card__number">
              01
            </div>

            <div className="education-card__body">
              <p className="education-card__institution">
                UNIVERSIDAD DE CHILE
              </p>

              <h3>Sociología</h3>

              <p>
                Formación universitaria en ciencias sociales,
                investigación y análisis de fenómenos sociales.
              </p>

              <button
                type="button"
                className="education-card__credential"
                onClick={() => setCredential(Sociologo)}
              >
                Ver credencial →
              </button>
            </div>

          </article>


          {/* INACAP */}

          <article className="education-card">

            <div className="education-card__number">
              02
            </div>

            <div className="education-card__body">
              <p className="education-card__institution">
                INACAP
              </p>

              <h3>Analista Programador</h3>

              <p>
                Formación técnica en programación y desarrollo
                de sistemas computacionales.
              </p>

              <button
                type="button"
                className="education-card__credential"
                onClick={() => setCredential(RankProg)}
              >
                Ver credencial →
              </button>
            </div>

          </article>


          {/* BIG DATA */}

          <article className="education-card">

            <div className="education-card__number">
              03
            </div>

            <div className="education-card__body">
              <p className="education-card__institution">
                PONTIFICIA UNIVERSIDAD CATÓLICA DE CHILE
              </p>

              <h3>Big Data y Machine Learning</h3>

              <p>
                Diplomado orientado al análisis de grandes volúmenes
                de datos y métodos de aprendizaje automático.
              </p>
            </div>

          </article>


          {/* IA */}

          <article className="education-card">

            <div className="education-card__number">
              04
            </div>

            <div className="education-card__body">
              <p className="education-card__institution">
                PONTIFICIA UNIVERSIDAD CATÓLICA DE CHILE
              </p>

              <h3>Inteligencia Artificial</h3>

              <p>
                Formación de postítulo en métodos y aplicaciones
                contemporáneas de inteligencia artificial.
              </p>
            </div>

          </article>

        </div>
      </section>


      {/* =====================================================
          PERFIL INTERDISCIPLINARIO
          ===================================================== */}

      <section className="about-profile">

        <div className="about-profile__heading">
          <p className="about-eyebrow">
            PERFIL INTERDISCIPLINARIO
          </p>

          <h2>
            Tres mundos que normalmente trabajan separados.
          </h2>
        </div>


        <div className="profile-columns">

          <article className="profile-column">
            <span className="profile-column__number">01</span>

            <h3>Ciencias sociales</h3>

            <ul>
              <li>Demografía</li>
              <li>Desigualdad</li>
              <li>Pobreza</li>
              <li>Territorio</li>
              <li>Investigación social</li>
            </ul>
          </article>


          <article className="profile-column">
            <span className="profile-column__number">02</span>

            <h3>Datos y estadística</h3>

            <ul>
              <li>Análisis estadístico</li>
              <li>Indicadores sociales</li>
              <li>Encuestas complejas</li>
              <li>Análisis espacial</li>
              <li>Machine Learning</li>
            </ul>
          </article>


          <article className="profile-column">
            <span className="profile-column__number">03</span>

            <h3>Programación</h3>

            <ul>
              <li>R</li>
              <li>Python</li>
              <li>Aplicaciones interactivas</li>
              <li>Visualización de datos</li>
              <li>Desarrollo web</li>
            </ul>
          </article>

        </div>
      </section>


      {/* =====================================================
          DEMOGRÁFICA
          ===================================================== */}

      <section className="about-demografica">

        <div className="about-demografica__content">

          <p className="about-eyebrow">
            DE LA FORMACIÓN A LA PRÁCTICA
          </p>

          <h2>Demográfica</h2>

          <p className="about-demografica__lead">
            Un espacio para transformar datos sociales en
            conocimiento territorial.
          </p>

          <p>
            El trabajo combina fuentes oficiales, métodos
            estadísticos, análisis espacial y herramientas
            computacionales para construir diagnósticos,
            indicadores y plataformas de exploración.
          </p>

          <div className="about-demografica__actions">

            <Link
              to="/censo"
              className="about-btn about-btn--primary"
            >
              Explorar Censo 2024 →
            </Link>

            <Link
              to="/plans"
              className="about-btn about-btn--secondary"
            >
              Ver servicios
            </Link>

          </div>
        </div>


        <div className="about-demografica__visual">

          <div className="about-data-card">

            <span className="about-data-card__label">
              DEMOGRÁFICA
            </span>

            <strong>
              Evidencia para comprender el territorio.
            </strong>

            <div className="about-data-card__grid">

              <div>
                <span>01</span>
                <p>Datos</p>
              </div>

              <div>
                <span>02</span>
                <p>Análisis</p>
              </div>

              <div>
                <span>03</span>
                <p>Territorio</p>
              </div>

              <div>
                <span>04</span>
                <p>Decisiones</p>
              </div>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          CONTACTO
          ===================================================== */}

      <section className="about-contact">

        <div>
          <p className="about-eyebrow">
            TRABAJEMOS JUNTOS
          </p>

          <h2>
            ¿Necesitas convertir datos en evidencia?
          </h2>

          <p>
            Podemos conversar sobre investigación, análisis
            territorial, visualización de datos o desarrollo
            de herramientas analíticas.
          </p>
        </div>

        <Link
          to="/contact"
          className="about-btn about-btn--light"
        >
          Contactar →
        </Link>

      </section>


      {/* =====================================================
          MODAL CREDENCIAL
          ===================================================== */}

      {credential && (
        <div
          className="credential-modal"
          onClick={closeCredential}
        >
          <div
            className="credential-modal__content"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="credential-modal__close"
              onClick={closeCredential}
              aria-label="Cerrar credencial"
            >
              ×
            </button>

            <img
              src={credential}
              alt="Credencial académica"
            />
          </div>
        </div>
      )}

    </main>
  )
}

export default About